<template>
<div class="row">
    <div class="col-12">
        <card>
            <div slot="raw-content" class="table-responsive">

                <paper-table :data="table1.data">
                    <div class="text-center" v-if="loader">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden"></span>
                        </div>
                    </div>
                    <table border="4" width="100%" style="border:4px;">
                        <tr>
                            <th>Nr.</th>
                            <th>Afati</th>
                            <th>Data</th>
                            <th>Lënda</th>
                            <th>Profesori</th>
                            <th>Nota</th>
                            <th>ECTS</th>
                            
                        </tr>
                        
                        <tr v-if="notat.length === 0">
                            <td>Nuk keni ende provime të kaluara</td>
                        </tr>
                        <tr v-for="(item,id) in notat">
                        
                            <td> {{ id+1 }}</td>
                            <td> {{ item.afati }} </td>
                            <td> {{ item.data }} </td>
                            <td> {{ item.lenda }} </td>
                            <td> {{ item.profesori }} </td>
                            <td> {{ item.nota }} </td>
                            <td> {{ item.kredite }} </td>

                        </tr>
                        <tr>
                            
                         
                            <td colspan="4"><strong>Totali i provimeve: {{ total_provime }} </strong></td>
                            <td></td>
                            <td><strong>{{ nota_mesatare }}</strong></td>
                            <td><strong>{{ total_ects }}</strong></td>
                            
                        </tr>
                    </table>
                </paper-table>
            </div>
        </card>
    </div>
</div>
</template>

<script>
import { PaperTable } from "@/components";
import moment from 'moment'
import { APISettings } from '../api/config.js'

const tableColumns = ["Afati", "Data", "Lenda", "Profesori", "Nota", "Kredite"];
var tableData = [{}];

export default {
    components: {
        PaperTable,
    },
    data() {
        return {
            table1: {
                title: "Notat",
                subTitle: "Here is a subtitle for this table",
                columns: [...tableColumns],
                data: [...tableData],

            },
            loader: false,
            notat: [],
            count_grade:"",
            tota_provime:"",
            total_ects:"",
            nota_mesatare:"",
            id:1,
        }
    },

    methods: {
        getData() {
            this.loader = true;
            var get_token = this.$cookies.get("accesstoken");
            fetch(APISettings.baseURL + `Notat/getNotat`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + get_token
                    },
                })
                .then(
                    (signinResponse) => { 
                        signinResponse.json().then((res) => {
                            if (signinResponse.status === 200) {
                                this.count_grade = res.length;
                                res.forEach(obj => {
                                    const formattedDate = moment(obj.data).format('DD/MM/YYYY');
                                    obj.data = formattedDate;
                                    this.notat = res;
                                });
                                this.loader = false;
                            } else if (signinResponse.status === 400) {
                                console.log("ERROR DATA1");
                            }
                        })
                    }).catch(error => {
                    console.log("ERROR DATA2");
                })
        },
        mesatarja() {
            this.loader1 = true;
            var get_token = this.$cookies.get("accesstoken");

            fetch(APISettings.baseURL + `Notat/getNotatenMesatare/`, {

                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + get_token
                    },
                })
                .then(
                    (signinResponse) => {
                        signinResponse.json().then((res) => {
                            this.total_provime = res[0].countNota;
                            this.total_ects = res[0].kredite;
                            this.nota_mesatare = res[0].nota_Mesatare;
                        })
                    }).catch(error => {
                    console.log("ERROR DATA2");
                })
        },
    
    },
    // Nota Mesatare


    beforeMount() {
        this.getData();
        this.mesatarja()
    },
};
</script>

<style>

</style>
